/** @jsxImportSource @emotion/react */
import { Trans } from "react-i18next";
import "twin.macro";

export const LoginTermsOfUseConfirmation = ({ checked, onChange, ...props }) => {
  return (
    <div tw="flex items-start" {...props}>
      <input
        id="termsOfUse"
        type="checkbox"
        tw="mt-0.5 h-4 w-4 text-third-600 focus:ring-third-500 border-gray-300 rounded"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        required
      />
      <label htmlFor="termsOfUse" tw="ml-2 block text-xs sm:text-sm">
        <Trans i18nKey="login.termsOfUseConfirmation">
          By signing up, you agree to our{" "}
          <a
            href={process.env.REACT_APP_TERMS_OF_USE_URL}
            rel="noopener noreferrer"
            target="_blank"
            tw="font-medium underline"
          >
            terms of service
          </a>{" "}
          and{" "}
          <a
            href={process.env.REACT_APP_PRIVACY_POLICY_URL}
            rel="noopener noreferrer"
            target="_blank"
            tw="font-medium underline"
          >
            privacy policy
          </a>
          .
        </Trans>
      </label>
    </div>
  );
};
